import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICurrency } from "../../../components/currency/Currencies";
import { last30DaysDateRange } from "../../../utils/date_formatter";
import uniqueId from "../../../utils/generateId";

export interface IPaginationState {
  lastVisitedPage: any;
  filters?: Record<string, string | number | null | any>;
  to_currency?: ICurrency;
  storeData: Record<
    number | any,
    {
      data: any;
      filters: Record<string, string | number>;
      to_currency?: ICurrency;
    }
  >;
}

const initialState: IPaginationState = {
  filters: {
    period: "last_30_days",
    start_date: last30DaysDateRange()[0],
    end_date: last30DaysDateRange()[1],
    branch: "",
  },
  to_currency: {},
  storeData: {},
  lastVisitedPage: 1,
};

const PaginationSlice = createSlice({
  name: "DashboardPagination",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<{ data: any }>) => {
      const { data }: { data: any } = action.payload;
      state.storeData = {
        [state.lastVisitedPage]: {
          data,
          filters: state.filters || {},
          to_currency: state.to_currency,
        },
      };
    },
    setLastVisitedPage: (state, action: PayloadAction<any>) => {
      state.lastVisitedPage = action.payload;
    },
    clearData: (state) => {
      state.storeData = {};
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
    setCurrency: (state, action: PayloadAction<ICurrency>) => {
      state.to_currency = action.payload;
    },
  },
});

export const {
  setData,
  setFilters,
  setCurrency,
  clearData,
  setLastVisitedPage,
} = PaginationSlice.actions;

export const selectPagination = (state: {
  DashboardPagination: IPaginationState;
}) => state.DashboardPagination;

export default PaginationSlice.reducer;
